// Single source of truth for the profile tab strip, shared by the desktop and mobile
// components so a new tab only has to be declared once.
// `isVisible` is optional: a tab without it is always shown.
const TABS = [
  { section: "dashboard", labelKey: "profile.dashboard" },
  { section: "notes", labelKey: "profile.notes.tabTitle" },
  { section: "coachvideos", labelKey: "profile.coachVideos" },
  { section: "questionnaire", labelKey: "profile.checkInQuestionnaire" },
  { section: "accountability", labelKey: "profile.dailyAccountability" },
  {
    section: "periodization",
    labelKey: "profile.periodization",
    isVisible: (athlete) => !athlete?.status?.inactive,
  },
  { section: "guides", labelKey: "profile.guides" },
  {
    section: "client-configuration",
    labelKey: "profile.clientConfiguration",
  },
];

export const getProfileTabs = (athlete) =>
  TABS.filter((tab) => !tab.isVisible || tab.isVisible(athlete));

export const getProfileTabHref = (section, athlete, organizationCoach) =>
  organizationCoach
    ? `/athlete-portal/profile?section=${section}&athlete=${athlete._id}&organizationCoach=${organizationCoach}`
    : `/athlete-portal/profile?section=${section}&athlete=${athlete._id}`;
